module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/main-settings/view-nationality/view-nationality.component.css
// module id = ./src/app/main-settings/view-nationality/view-nationality.component.css
// module chunks = main